import barBus from './bus'

export function afterEachResolver (to, from) {
  setTimeout(() => {
    if (!from.name) {
      barBus.$emit('directlyEnter')
    }

    barBus.$emit('routerChange', to)
  })
}
